<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="$id('editRelationModal')" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="$id('editRelationModal')">{{header}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <auto-complete-text-edit
                                    :id="$id('product')"
                                    :name="'product'"
                                    :placeholder="$t('page.product.edit.modal.product')"
                                    :url="'/manage/storage/booking/complete_sku'"></auto-complete-text-edit>
                            <input type="text" name="quantity" class="form-control"
                                   :placeholder="$t('page.product.edit.modal.quantity')"
                                   v-if="isBundle === true"
                                   :ref="$id('quantity')"/>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('no')">{{$t('page.product.edit.modal.close')}}</button>
                        <button type="button" class="btn btn-primary" @click="checkAndSubmit()">{{$t('page.product.edit.modal.save')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <QuestionModal :id="$id('errorModal')" :title="$t('page.product.edit.modal.error_title')" :message="errorMsg" @yes="toggleQuestion" @no="toggleQuestion" ></QuestionModal>
    </div>
</template>

<script>
    import QuestionModal from "../QuestionModal";

    export default {
        name: "EditRelationModal",
        components: {
            QuestionModal,
        },
        data: function() {
            return {
                errorMsg: "",
                header: "",
            }
        },
        props:{
            id: {
                type: String,
                required: true,
            },
            title: String,
            message: String,
            isBundle: {
                type: Boolean,
                default: false,
            },
        },
        beforeMount: function(){
            if( this.isBundle ){
                this.header = this.$t('page.product.edit.modal.edit_bundle_title');
            } else {
                this.header = this.$t('page.product.edit.modal.edit_configurable_title');
            }
        },
        methods:{
            checkAndSubmit: function (event) {
                let errorMsg = "";

                if(this.isBundle === true && this.$refs[this.$id('quantity')].value.length <= 0){
                    errorMsg = this.$t('page.product.edit.modal.insert_quantity');
                }

                let regex = /^(\d*)/;

                if(regex.exec(this.$refs[this.$id('quantity')].value)[0] === ""){
                    errorMsg = this.$t('page.product.edit.modal.quantity_is_no_number');
                }

                if( errorMsg === "") {
                    $('#' + this.id).modal('toggle');

                    this.$emit('save', {
                        type: this.isBundle ? 'bundle' : 'configurable',
                        sku: $('#' + this.$id('product input')).val().split(' - ', 2)[0],
                        quantity: this.$refs[this.$id('quantity')].value,
                    });
                } else {
                    this.errorMsg = errorMsg;
                    $('#' + this.$id('errorModal')).modal('toggle');
                }
            },
            toggleQuestion: function () {
                $('#' + this.$id('errorModal')).modal('toggle');
            }
        }
    }
</script>
